/* eslint-disable max-len */
import {
  SEARCH_FORM_REDIRECT,
  SEARCH_FORM_ACTIVATION,
  SEARCH_REDIRECT_TYPE_PRODUCT,
  SEARCH_REDIRECT_TYPE_MERCHANT_MULTIPLE,
  SEARCH_REDIRECT_TYPE_MERCHANT_SINGLE,
  SEARCH_REDIRECT_TYPE_MERCHANT_TOMBSTONE,
  SEARCH_REDIRECT_TYPE_NO_RESULTS,
  SEARCH_REDIRECT_TYPE_URL,
  SEARCH_FORM_QUICK_SEARCH_REDIRECT,
} from '../actions/types';

const VALUE_NOT_SET = '(not set)';

export const buildSuggestionsString = (querySuggestions = {}) => {
  const { synonyms = [], online = [], instore = [] } = querySuggestions;
  const synonymsMerchantsNames = synonyms.map(match => match.merchant.name);
  const onlineMerchantsNames = online.map(match => match.merchant.name);
  const instoreMerchantsNames = instore.map(match => `${match.merchant.name} (Instore)`);

  return [...synonymsMerchantsNames, ...onlineMerchantsNames, ...instoreMerchantsNames].join(', ') || VALUE_NOT_SET;
};

export const getDestinationMerchantsNames = (destinationMerchants = []) => (
  destinationMerchants.map(merchant => merchant.name).join(', ') || VALUE_NOT_SET
);

const recordSearchFormActivation = (actionData) => {
  const { quickSearchMatches, searchBoxFormType, keywords } = actionData.data;

  return {
    category: searchBoxFormType,
    action: 'Activation',
    label: `${keywords} | ${buildSuggestionsString(quickSearchMatches)}`,
    custom: {
      merchant: null,
    },
  };
};

const recordSearchFormRedirect = (actionData) => {
  const {
    searchFormRedirectType, searchFormDestinationMerchants, quickSearchMatches,
    searchBoxFormType, keywords, searchFormRedirectUrl,
  } = actionData.data;
  let label;
  let action;

  switch (searchFormRedirectType) {
    case SEARCH_REDIRECT_TYPE_URL:
      action = 'Url redirect';
      label = `${searchFormRedirectUrl}`;
      break;
    case SEARCH_REDIRECT_TYPE_MERCHANT_SINGLE:
      action = 'Merchant result - single';
      label = `${keywords} | ${buildSuggestionsString(quickSearchMatches)} | ${getDestinationMerchantsNames(searchFormDestinationMerchants)}`;
      break;
    case SEARCH_REDIRECT_TYPE_MERCHANT_MULTIPLE:
      action = 'Merchant result - multiple';
      label = `${keywords} | ${buildSuggestionsString(quickSearchMatches)} | ${getDestinationMerchantsNames(searchFormDestinationMerchants)}`;
      break;
    case SEARCH_REDIRECT_TYPE_MERCHANT_TOMBSTONE:
      action = 'Tombstone result';
      label = `${keywords} | ${buildSuggestionsString(quickSearchMatches)} | ${getDestinationMerchantsNames(searchFormDestinationMerchants)}`;
      break;
    case SEARCH_REDIRECT_TYPE_PRODUCT:
      action = 'Product search result redirect';
      label = `${keywords} | ${buildSuggestionsString(quickSearchMatches)}`;
      break;
    case SEARCH_REDIRECT_TYPE_NO_RESULTS:
      action = 'No result page redirect';
      label = `${keywords} | ${buildSuggestionsString(quickSearchMatches)}`;
      break;
    default:
      action = VALUE_NOT_SET;
      label = VALUE_NOT_SET;
  }

  return {
    category: searchBoxFormType,
    action,
    label,
    custom: {
      merchant: null,
    },
    transport: 'beacon',
  };
};

const recordQuickSearchRedirect = (actionData) => {
  const {
    quickSearchMatches,
    destinationMerchant,
    searchBoxFormType,
    keywords,
  } = actionData.data;

  return {
    category: searchBoxFormType,
    action: `typeahead click - ${destinationMerchant.type} merchant`,
    label: `${keywords} | ${buildSuggestionsString(quickSearchMatches)} | ${destinationMerchant.name}`,
    custom: {
      merchant: null,
    },
    transport: 'beacon',
  };
};

export const searchFormGaActionEvents = {
  [SEARCH_FORM_ACTIVATION]: recordSearchFormActivation,
  [SEARCH_FORM_REDIRECT]: recordSearchFormRedirect,
  [SEARCH_FORM_QUICK_SEARCH_REDIRECT]: recordQuickSearchRedirect,
};
